import { _request } from '@@/utils/request'
import CONFIG from '@@/config'

export const {
  CUSTOMER_HOST
} = CONFIG

export const customerRequest = {
  get: (url, data, config = {}) => _request.get(`${CUSTOMER_HOST}${url}`, data, { ...config }),
  post: (url, data, config = {}) => _request.post(`${CUSTOMER_HOST}${url}`, data, { ...config })
}

// 获取下单人信息列表
export const getOrderManPage = params => customerRequest.get('/web/encodeDecode/order/man/query/page', params, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})
// 添加下单人信息
export const addOrderMan = data => customerRequest.post('/web/encodeDecode/order/man/insert', data, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})

// 获取工程师信息
export const getEngineerList = data => customerRequest.post(`/web/encodeDecode/engineer/getListByHqId?t=${+new Date()}`, data, {
  resCryptoKeys: 'all',
  resultKey: 'body'
})
// 添加工程师信息
export const addEngineer = data => customerRequest.post('/web/encodeDecode/engineer/insert', data, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})

// 获取发票列表
export const getInvoiceList = params => customerRequest.get('/web/encodeDecode/invoice/query/list', params, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})
// 新增发票
export const addInvoice = data => customerRequest.post('/web/encodeDecode/invoice/insert', data, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})
// 更新发票
export const updateInvoice = data => customerRequest.post('/web/encodeDecode/invoice/update', data, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})

// 地址列表
export const getNewAddressList = params => customerRequest.get('/web/encodeDecode/index/user/address/list', params, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})
// 添加地址
export const addNewAddressInfo = data => customerRequest.post('/web/encodeDecode/index/user/address/insert', data, {
  reqCryptoKeys: 'all',
  resCryptoKeys: 'all',
  resultKey: 'body'
})

//  获取用户是否账期客户和数电增值税（专用）发票数量
export const getUserInvoiceNum = params => customerRequest.get('/web/invoice/getUserInvoiceNum', params)

// 获取用户未读信息
export const getMessageNum = data => customerRequest.post('/web/message/queryUserMessageNotReadNum', data)
